import Banner from 'app/components/partials/banner';
import ContentBlocks from 'app/components/content-blocks/index';
import PropTypes from 'prop-types';
import ScalableObject from 'app/components/partials/scalable-object';
import React, { Component } from 'react';


class Page extends Component {
    constructor(props) {
        super(props);
        this.MAP_PROPS = {
            image: {
                src: props.globalFields.map,
                alt: 'Internal Map'
            }
        };

        this.state = {
            mapProps: this.MAP_PROPS
        };
    }

    render() {
        const {
            blocks,
            name: title,
            highlighted_information: highlight,
            main_images: images,
            latin_name: latinName,
            short_description: description,
        } = this.props.data;

        return (
            <div className="page || page-view">
                <Banner
                    title={title}
                    subtitle={latinName}
                    introduction={description}
                    highlight={highlight}
                    images={images} />
                <div className="constrain-width large">
                    <ScalableObject {...this.state.mapProps} />
                </div>
                <ContentBlocks data={blocks} />
            </div>
        );
    }
}

Page.propTypes = {
    data: PropTypes.object.isRequired,
    globalFields: PropTypes.object.isRequired
};

export default Page;
